import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { CategoryPlanRun, CategoryPlanSuggestion } from './types';

export type CategoryPlanRunDetailData = Readonly<{
  run: CategoryPlanRun;
  suggestions: CategoryPlanSuggestion[];
}>;

type CategoryPlanRunDetailResponse = Readonly<{
  run: CategoryPlanRun;
  suggestions: CategoryPlanSuggestion[];
}>;

export async function getCategoryPlanRun(
  scope: RequestScope,
  args: { runId: number },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<CategoryPlanRunDetailData>> {
  try {
    const res = await scopedChannelApi(scope).get<CategoryPlanRunDetailResponse>(`atts/category-plan/runs/${args.runId}`, {
      ...options,
      headers: buildAsturHeaders(),
    });

    const { run, suggestions } = res.data ?? {};
    if (!run || !Array.isArray(suggestions)) {
      throw new Error('Invalid category plan run response');
    }

    return { data: { run, suggestions }, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
